import * as authServices from '@/services/authServices';
import * as userServices from '@/services/userServices';
import * as storageServices from '@/services/storageServices';

export default {
  /*
   * ユーザーのプロフィールを変更
   * payload: {photoFile, nickname, userType}
   */
  async updateUserProfile({ commit }, payload) {
    const uid = authServices.getUID();
    const iconFolderPath = `users/${uid}/icon`;
    const thumbnailFolderPath = `users/${uid}/thumbnail`;

    if (payload.photoFile) {
      // delete old icon file
      await storageServices.deletePhotoByFolderPath(iconFolderPath);
      const photoURL = await storageServices.uploadPhoto(
        iconFolderPath,
        payload.photoFile
      );
      payload['photoURL'] = photoURL;
      delete payload['photoFile'];
    }

    if (payload.imageFile) {
      const thumbnailURL = await storageServices.uploadPhoto(
        thumbnailFolderPath,
        payload.imageFile
      );
      payload['thumbnailURL'] = thumbnailURL;
      delete payload['imageFile'];
    }

    const snapshotData = await userServices.setUserDoc(uid, payload);
    commit('user/loadUserDoc', snapshotData);
  }
};
